import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Import components for routing

import PublicBankHome from './Bank/Page/PublicBank/PublicBankHome/PublicBankHome';
import AccountPrint from './Bank/Page/PublicBank/AccountPrint/AccountPrint';
import RemittanceCalculation from './Bank/Page/PublicBank/RemittanceCalculation/RemittanceCalculation';
import DPSCalculation from './Bank/Page/PublicBank/DPSCalculation/DPSCalculation';
import FDRCalculation from './Bank/Page/PublicBank/FDRCalculation/FDRCalculation';
import LoanCalculation from './Bank/Page/PublicBank/LoanCalculation/LoanCalculation';
import ContactUs from './Bank/Page/PublicBank/ContactUs/ContactUs';


// import 'bootstrap/dist/css/bootstrap.min.css';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Bank Project Start */}
        {/* Public Page Start */}

        <Route path="/UserHome" element={<PublicBankHome />} />
        <Route path="/" element={<PublicBankHome />} />
        <Route path="*" element={<PublicBankHome />} />
        
        <Route path="/MyBank" element={<PublicBankHome />} />
        <Route path="/AccountPrint" element={<AccountPrint />} />
        <Route path="/RemittanceCalculation" element={<RemittanceCalculation />} />
        <Route path="/DPSCalculation" element={<DPSCalculation />} />
        <Route path="/FDRCalculation" element={<FDRCalculation />} />
        <Route path="/LoanCalculation" element={<LoanCalculation />} />
        <Route path="/ContactUs" element={<ContactUs />} />

        {/* Public Page End */}
        {/* Bank Project End */}
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;
